import { LocationMarkerIcon, PhoneIcon, WifiIcon, MailIcon } from "@heroicons/react/solid";

import Title from "../Title";

const Footer = () => {
    return (
        <section className="container  bg-sky-800 flex flex-wrap text-slate-50 relative bottom-11">
            <div className="us w-6/12">
                <Title type="light">تماس باما</Title>
                <div className="mx-10 my-4 flex">
                    <LocationMarkerIcon className="w-5 ml-1" />
                    ایران، آمل، خیابان طالقانی
                </div>
                <div className="mx-10 my-4 flex">
                    <PhoneIcon className="w-5 ml-1" />
                    01113256487
                </div>
                <div className="mx-10 my-4 flex">
                    <WifiIcon className="w-5 ml-1" />
                    9746126
                </div>
                <div className="mx-10 my-4 flex">
                    <MailIcon className="w-5 ml-1" />
                    test@gmail.com
                </div>
            </div>
            <div className="link w-3/12">
                <Title type="light">لینک های مفید</Title>
                <div className="mx-10 my-4">
                    <p>دانشگاه،گلستان،تستی</p>
                    <p>تغذی،مشاوره،اسلامی</p>
                    <p>انجمن علمی،انجمن اسلامی،دانشکده</p>
                </div>
            </div>
            <div className="link w-3/12">
                <Title type="light">ویژه همکاران</Title>
                <div className="mx-10 my-4">
                    <p>امورمالی دانشگاه</p>
                    <p>اتوماسیون دانشگاه</p>
                    <p>پست الکترونیک دانشگاه</p>
                </div>
            </div>
            <p className="w-full text-center bg-sky-900 mt-4 py-2">کلیه حقوق برای دانشگاه تخصصی فناوری های نوین آمل محفوظ می باشد.</p>
        </section>
    );
};

export default Footer;
